import React from "react";
import Scan from "../../assets/images/scan.png";

const ComingSoon = () => {
  return (
      <>
          <div className="coming_soon">
            <div className="container">
                <div className="row justify-content-center align-item-center">
                    <div className="col-md-4">
                          <h1 class="fs_64 fw_700 text-capitalize mb_20">Something amazing is on the way!</h1>
                          <p>While we finish building our website, you can continue to order easily. Scan the QR code below or tap the link to proceed with your order.</p>
                          
                    </div>
                    <div className="col-md-4">
                        <div className="d-md-flex flex-column justify-content-center align-items-center">
                             
                              
                              <a href="https://wa.me/message/3F3G7XGAZBGSH1" className="button btn-solid text-decoration-none" target="_blank">Order Now on Whatsapp</a>
                              <div className="qr">
                                  OR
                              </div>
                              <img src={Scan} alt="" className="scan" />
                        </div>
                          
                    </div>
                </div>
            </div>
          </div>
      </>
  );
};

export default ComingSoon;
